<script setup lang="ts">
const props = defineProps<{
  headers: {
    name: string;
    header: string;
    isItemsTextLeft?: boolean;
  }[];
  items: {
    [key: string]: string | number;
  }[];
}>();
</script>
<template>
  <div class="<md:px-2">
    <div
      class="grid text-center mt-4 text-sm"
      :style="`grid-template-columns: repeat(${headers.length}, minmax(0, 1fr));`"
    >
      <div
        v-for="header of props.headers"
        :key="header.name"
        class="py-4 px-8 text-center border-solid border-black/25 border-t-0 border-r-1 border-b-1 border-l-0 bg-gray-light flex items-center justify-center"
        :class="{
          'border-r-0': headers.indexOf(header) === headers.length - 1,
        }"
        v-html="header.header"
      ></div>
    </div>
    <div v-for="item in items" :key="item[0]" class="w-full">
      <div
        class="grid text-center"
        :style="`grid-template-columns: repeat(${headers.length}, minmax(0, 1fr));`"
      >
        <div
          v-for="header of props.headers"
          :key="header.name"
          class="<md:px-0 py-4 px-8 text-center border-black/25 border-solid border-t-0 border-r-1 border-b-1 border-l-0 flex items-center justify-center"
          :class="{
            'border-r-0': headers.indexOf(header) === headers.length - 1,
            'border-b-0': items.indexOf(item) === items.length - 1,
          }"
        >
          <span
            :class="{ '!text-left': header.isItemsTextLeft }"
            class="w-full"
            v-html="item[header.name]"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>
